import { useState, useEffect } from 'react';
import UserFrame from "../organisms/UserFrame";
import USCollection from "../organisms/USCollection";
import { Container, Box } from '@mui/material';

const UserSiteMapTemplate = () => {
    const [windowWidth, setWindowWidth] = useState(window.outerWidth);

    useEffect(() => {
        const updateWidth = () => {
            setWindowWidth(window.outerWidth);
        };
        window.addEventListener('resize', updateWidth);
        return () => {
            window.removeEventListener('resize', updateWidth); // リスナーを解除
        };
    }, []); // 空配列依存性のため、初回マウント時にのみ実行

    return (
        <UserFrame title=''>
            <Container maxWidth='xl'>
                <Box sx={{ height: '640px', maxWidth: '100%', overflowY: 'scroll' }}>
                    <USCollection windowWidth={windowWidth} />
                    <USCollection windowWidth={windowWidth} />
                    <USCollection windowWidth={windowWidth} />
                </Box>
            </Container>
        </UserFrame>
    );
};

export default UserSiteMapTemplate;
